module.exports = __webpack_public_path__ + "static/media/user-b.c5c3b2db.png";